import { GridCellProps } from "@progress/kendo-react-grid";
import { GridRowClickProps } from "../../GridRowClickProps";

export type EnumerationCellProps<T> = GridCellProps &
  Partial<GridRowClickProps> & {
    mapping: Map<T, string>;
  };

export function EnumerationCell<T>({
  mapping,
  onRowClick = () => undefined,
  ...props
}: EnumerationCellProps<T>) {
  return (
    <td
      className={props.className}
      style={{ ...props.style }}
      colSpan={props.colSpan}
      role="gridcell"
      aria-colindex={props.ariaColumnIndex}
      aria-selected={props.isSelected}
      onClick={() => onRowClick(props.dataItem)}
    >
      {mapping.get(props.field && props.dataItem[props.field])}
    </td>
  );
}
